(function () {
  var NAMES = [
    'Carlos M.', 'María G.', 'Juan P.', 'Ana L.', 'Luis R.',
    'Sofía H.', 'Miguel A.', 'Fernanda C.', 'Diego T.', 'Valentina S.',
    'Roberto E.', 'Gabriela F.', 'Alejandro N.', 'Paola V.', 'Eduardo B.',
    'Daniela O.', 'Javier Q.', 'Lucía W.', 'Sergio I.', 'Mónica K.'
  ];

  var CITIES = [
    'Ciudad de México', 'Guadalajara', 'Monterrey', 'Puebla', 'Tijuana',
    'León', 'Mérida', 'Querétaro', 'San Luis Potosí', 'Aguascalientes'
  ];

  var TIMES = [
    'hace 2 minutos', 'hace 5 minutos', 'hace 8 minutos',
    'hace 12 minutos', 'hace 18 minutos', 'hace 23 minutos'
  ];

  function rand(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function getInitial(name) {
    return name.charAt(0).toUpperCase();
  }

  function createToast() {
    var existing = document.getElementById('sp-toast');
    if (existing) existing.remove();

    var name = rand(NAMES);
    var city = rand(CITIES);
    var time = rand(TIMES);

    var el = document.createElement('div');
    el.className = 'sp-toast';
    el.id = 'sp-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');

    el.innerHTML =
      '<div class="sp-toast__avatar">' + getInitial(name) + '</div>' +
      '<div class="sp-toast__body">' +
        '<div class="sp-toast__name">' + name + ' · ' + city + '</div>' +
        '<div class="sp-toast__text">Acaba de realizar un pedido ✅</div>' +
        '<div class="sp-toast__time">' + time + '</div>' +
      '</div>' +
      '<div class="sp-toast__dot"></div>';

    document.body.appendChild(el);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add('sp-toast--visible');
      });
    });

    setTimeout(function () {
      el.classList.remove('sp-toast--visible');
      setTimeout(function () {
        if (el.parentNode) el.remove();
      }, 500);
    }, 4500);
  }

  function scheduleNext() {
    var delay = 25000 + Math.floor(Math.random() * 20000);
    setTimeout(function () {
      createToast();
      scheduleNext();
    }, delay);
  }

  function init() {
    setTimeout(function () {
      createToast();
      scheduleNext();
    }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
